export default {
  login: 'Login',
  error: 'ErrorPage',
};
